// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_fragment(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
              "Buyer",
              "Landlord",
              "Renter",
              "Seller"
            ]);
}

var fragmentConverter = {"__root":{"":{"u":"fragment"}}};

var fragmentConverterMap = {
  fragment: unwrap_fragment
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function buyerNeedMatchingType_decode($$enum) {
  if ($$enum === "BROADCAST" || $$enum === "QUIET") {
    return $$enum;
  }
  
}

function buyerNeedMatchingType_fromString(str) {
  return buyerNeedMatchingType_decode(str);
}

function forSalePropertyMatchingType_decode($$enum) {
  if ($$enum === "QUIET" || $$enum === "ONE_WAY" || $$enum === "BROADCAST" || $$enum === "QUIET_ANONYMOUS") {
    return $$enum;
  }
  
}

function forSalePropertyMatchingType_fromString(str) {
  return forSalePropertyMatchingType_decode(str);
}

function rentalNeedMatchingType_decode($$enum) {
  if ($$enum === "BROADCAST") {
    return $$enum;
  }
  
}

function rentalNeedMatchingType_fromString(str) {
  return rentalNeedMatchingType_decode(str);
}

function rentalPropertyMatchingType_decode($$enum) {
  if ($$enum === "BROADCAST") {
    return $$enum;
  }
  
}

function rentalPropertyMatchingType_fromString(str) {
  return rentalPropertyMatchingType_decode(str);
}

var Utils = {
  buyerNeedMatchingType_decode: buyerNeedMatchingType_decode,
  buyerNeedMatchingType_fromString: buyerNeedMatchingType_fromString,
  forSalePropertyMatchingType_decode: forSalePropertyMatchingType_decode,
  forSalePropertyMatchingType_fromString: forSalePropertyMatchingType_fromString,
  rentalNeedMatchingType_decode: rentalNeedMatchingType_decode,
  rentalNeedMatchingType_fromString: rentalNeedMatchingType_fromString,
  rentalPropertyMatchingType_decode: rentalPropertyMatchingType_decode,
  rentalPropertyMatchingType_fromString: rentalPropertyMatchingType_fromString
};

var node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canDelete",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "kind": "RequiredField",
    "field": {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "matchingType",
      "storageKey": null
    },
    "action": "THROW"
  },
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MyClientsWidgetDeleteDialog_clientV5",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "kind": "RequiredField",
          "field": {
            "alias": "forSaleProperty",
            "args": null,
            "concreteType": "ForSalePropertyV5",
            "kind": "LinkedField",
            "name": "property",
            "plural": false,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "alias": "forSalePropertyMatchingType",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "matchingType",
                  "storageKey": null
                },
                "action": "THROW"
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          "action": "THROW"
        }
      ],
      "type": "Seller",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "kind": "RequiredField",
          "field": {
            "alias": null,
            "args": null,
            "concreteType": "RentalPropertyV5",
            "kind": "LinkedField",
            "name": "property",
            "plural": false,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "alias": "rentalPropertyMatchingType",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "matchingType",
                  "storageKey": null
                },
                "action": "THROW"
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          "action": "THROW"
        }
      ],
      "type": "Landlord",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "kind": "RequiredField",
          "field": {
            "alias": null,
            "args": null,
            "concreteType": "RentalNeedV5",
            "kind": "LinkedField",
            "name": "rentalNeed",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          "action": "THROW"
        }
      ],
      "type": "Renter",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "kind": "RequiredField",
          "field": {
            "alias": null,
            "args": null,
            "concreteType": "BuyerNeedV5",
            "kind": "LinkedField",
            "name": "buyerNeed",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          "action": "THROW"
        }
      ],
      "type": "Buyer",
      "abstractKey": null
    }
  ],
  "type": "ClientV5",
  "abstractKey": "__isClientV5"
};
})());

var wrap_fragment = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment = unwrap_fragment;
exports.wrap_fragment = wrap_fragment;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
